import { gql } from "@apollo/client";

export const LOGIN_INTO_CLIENT_PORTAL = gql`
  query Query($clientId: String!) {
    clientUrl(client_id: $clientId)
  }
`;

export const GET_CLIENTS = gql`
  query (
    $groupKeys: [String]
    $rowGroups: [RowGroup]
    $startRow: Int
    $endRow: Int
    $sorting: [SortModel]
    $filterModel: FilterModel
    $payRollState: String
    $payRollDuration: DateRange
  ) {
    clientsList(
      startRow: $startRow
      endRow: $endRow
      sorting: $sorting
      groupKeys: $groupKeys
      rowGroups: $rowGroups
      filterModel: $filterModel
      payRollState: $payRollState
      payRollDuration: $payRollDuration
    ) {
      clientsData {
        name
        _id
        client_id
        url
        logo
        auth_token
        created_by
        updated_by
        status
        client_code
        created_at
        payroll_lock
        payroll_month
        payroll_release
        assigned_status
        last_activity
        payrollSettings {
          pay_frequency
          off_days
          payment_schedule
        }
        template {
          template_id
          signed_of_by
          signed_of_at
          last_signed_of_at
          has_signed_before
          last_signed_of_by
          client_id
          templateMilestones {
            completedDate
            milestone_id
            template_id
            t_value
            owner
            milestones {
              name
              _id
              is_primary
              color_code
            }
            order
          }
        }

        templateStatus
      }
      total
    }
  }
`;

export const GET_CLIENTS_REPORTEES = gql`
  query ReporteesClientsList(
    $groupKeys: [String]
    $rowGroups: [RowGroup]
    $startRow: Int
    $endRow: Int
    $sorting: [SortModel]
    $filterModel: FilterModel
  ) {
    reporteesClientsList(
      startRow: $startRow
      endRow: $endRow
      sorting: $sorting
      groupKeys: $groupKeys
      rowGroups: $rowGroups
      filterModel: $filterModel
    ) {
      clientsData {
        _id
        name
        client_id
        template {
          template_id
          client_id
          signed_of_at
          signed_of_by
          last_signed_of_at
          last_signed_of_by
          has_signed_before
          templateMilestones {
            _id
            milestone_id
            template_id
          }
        }
        templateStatus
        payrollSettings {
          pay_frequency
          off_days
          payment_schedule
          week_start_day
        }
        status
        assignedReporteeUsers {
          _id
          first_name
          last_name
          email
        }
      }
      total
    }
  }
`;

export const ACTIVE_USERS_LIST = gql`
  query ActiveUsers($clientId: String) {
    activeUsers(client_id: $clientId) {
      _id
      name
      profile_pic
      name
    }
  }
`;

export const UNASSIGN_CLIENTS = gql`
  mutation UnassignTeam($userId: String!, $clients: [String]) {
    unassignTeam(user_id: $userId, clients: $clients)
  }
`;

export const ASSIGNED_CLIENTS = gql`
  query ClientsList(
    $startRow: Int
    $endRow: Int
    $userId: String
    $sorting: [SortModel]
    $filterModel: FilterModel
  ) {
    clientsList(
      startRow: $startRow
      endRow: $endRow
      userId: $userId
      sorting: $sorting
      filterModel: $filterModel
    ) {
      total
      clientsData {
        _id
        name
        client_id
        url
        logo
        auth_token
        created_by
        updated_by
        status
        created_at
        payroll_lock
        payroll_month
        payroll_release
        assigned_status
        assigned_by
        assigned_date
        is_primary
        role
        master_role
      }
    }
  }
`;

export const ASSIGNED_CLIENTS_WITH_MOVEUSER = gql`
  query ClientsList(
    $startRow: Int
    $endRow: Int
    $userId: String
    $sorting: [SortModel]
    $filterModel: FilterModel
    $moveToUser: String
  ) {
    clientsList(
      startRow: $startRow
      endRow: $endRow
      userId: $userId
      sorting: $sorting
      filterModel: $filterModel
      moveToUser: $moveToUser
    ) {
      total
      clientsData {
        _id
        name
        client_id
        url
        logo
        auth_token
        created_by
        updated_by
        status
        created_at
        payroll_lock
        payroll_month
        payroll_release
        assigned_status
        assigned_by
        assigned_date
        is_primary
        role
        master_role
        isAssignedToLoggedUser
      }
    }
  }
`;

export const UNASSIGNED_CLIENTS = gql`
  query ClientsData(
    $userId: String!
    $startRow: Int
    $sorting: [SortModel]
    $endRow: Int
    $filterModel: FilterModel
  ) {
    unassignedClientsList(
      userId: $userId
      startRow: $startRow
      sorting: $sorting
      endRow: $endRow
      filterModel: $filterModel
    ) {
      clientsData {
        name
        client_id
        url
        logo
        _id
      }
      total
    }
  }
`;

export const MOVE_ASSIGN_FROM_ONE_TO_ONE = gql`
  mutation BulkMoveClients(
    $fromUser: String!
    $toUser: String!
    $clientIds: [String!]
  ) {
    bulkMoveClients(
      from_user: $fromUser
      to_user: $toUser
      clientIds: $clientIds
    )
  }
`;

export const GET_PAYROLL_DETAILS = gql`
  query PayrollOverview($year: Int, $month: Int, $clientId: [String]) {
    payrollOverview(year: $year, month: $month, client_ids: $clientId) {
      month
      data {
        payslipRelesed
        payrollLock
      }
      year
    }
  }
`;
export const GET_ACTIVITY_LOGS_BY_CLIENT_ID = gql`
  query AuditLogs(
    $startRow: Int
    $endRow: Int
    $sorting: [SortModel]
    $filterModel: FilterModel
    $clientId: String
  ) {
    auditLogs(
      startRow: $startRow
      endRow: $endRow
      sorting: $sorting
      filterModel: $filterModel
      clientId: $clientId
    ) {
      auditsData {
        audit_type_id
        user_id
        ip_address
        message
        createdAt
        activity_status
        _id
        user_name
        type
        client_id
      }
      total
    }
  }
`;

export const EXPORT_ACTIVITY = gql`
  query AuditLogs(
    $startRow: Int
    $endRow: Int
    $userId: String
    $exportPdf: String
    $filterModel: FilterModel
    $sorting: [SortModel]
    $clientId: String
  ) {
    auditLogs(
      startRow: $startRow
      endRow: $endRow
      userId: $userId
      exportPdf: $exportPdf
      filterModel: $filterModel
      sorting: $sorting
      clientId: $clientId
    ) {
      total
      auditsData {
        file_b64_link
        message
        file_name
      }
    }
  }
`;

export const GET_HEAD_COUNT = gql`
  query HeadsCount(
    $year: Int
    $month: Int
    $endRow: Int
    $startRow: Int
    $searchTerm: String
  ) {
    headsCount(
      year: $year
      month: $month
      endRow: $endRow
      startRow: $startRow
      searchTerm: $searchTerm
    ) {
      headCountDetails {
        month
        data {
          headsCount
        }
        year
        clientDetails {
          name
          _id
          url
          status
          assigned_status
        }
        last_activity
      }
      total
    }
  }
`;

export const ASSIGN_NEW_SPOC = gql`
  mutation AssignClientSPOC(
    $clientId: String!
    $email: String!
    $name: String!
    $greytHrAccess: Boolean
    $greytHrRole: String
    $assignClientSpocId: String
    $mobileNumber: String
  ) {
    assignClientSPOC(
      client_id: $clientId
      email: $email
      name: $name
      greyt_hr_access: $greytHrAccess
      greyt_hr_role: $greytHrRole
      id: $assignClientSpocId
      mobile_number: $mobileNumber
    )
  }
`;

export const SIGN_OFF_TEMPLATE = gql`
  mutation SignOffClientTemplate($clientId: String!) {
    signOffClientTemplate(client_id: $clientId)
  }
`;

export const CREATE_PAY_POLICY = gql`
  mutation SaveClientPayPolicy(
    $clientId: String!
    $payFrequency: String!
    $offDays: String!
    $paymentSchedule: String!
    $weekStartDay: String!
  ) {
    saveClientPayPolicy(
      client_id: $clientId
      pay_frequency: $payFrequency
      off_days: $offDays
      payment_schedule: $paymentSchedule
      week_start_day: $weekStartDay
    )
  }
`;

export const GET_PAY_POLICY = gql`
  query ClientPayPolicy($clientId: String!) {
    clientPayPolicy(client_id: $clientId) {
      pay_frequency
      off_days
      payment_schedule
      week_start_day
    }
  }
`;

export const GET_PAYMENT_SCHEDULE = gql`
  query PaymentScheduleOptions {
    paymentScheduleOptions {
      id
      title
    }
  }
`;

export const GET_ASSIGNED_SPOCS = gql`
  query AssignedSPOCList($clientId: String!, $status: String!) {
    assignedSPOCList(client_id: $clientId, status: $status) {
      email
      name
      phone_number
      mobile_number
      updated_by
      createdAt
      updatedAt
      greyt_hr_access
      greyt_hr_role
      _id
      status
      updated_by_details {
        _id
        first_name
        last_name
        email
      }
    }
  }
`;

export const DELETE_POC_ASSINMENT = gql`
  mutation DeleteClientSPOC($deleteClientSpocId: String!) {
    deleteClientSPOC(id: $deleteClientSpocId)
  }
`;

export const REVOKE_POC_ASSINMENT = gql`
  mutation RevokeSPOCAccess($revokeSpocAccessId: String!) {
    revokeSPOCAccess(id: $revokeSpocAccessId)
  }
`;

export const EXPORTS_CLIENTS = gql`
  query ExportClientsList(
    $userId: String
    $sorting: [SortModel]
    $filterModel: FilterModel
  ) {
    exportClientsList(
      userId: $userId
      sorting: $sorting
      filterModel: $filterModel
    ) {
      _id
      name
      client_code
      url
      status
      assigned_users {
        email
        first_name
        last_name
        role
        master_role
      }
    }
  }
`;

export const PERMISSION_WISE_ALL_CLIENTS = gql`
  query SupportClientList {
    supportClientList {
      _id
      name
      client_id
      url
      client_code
    }
  }
`;

export const GET_GLOBAL_SEARCH = gql`query SupportClientList($searchName: String) {
  supportClientList(searchName: $searchName) {
    _id
    name
    client_id
    client_code
    url
  }
}`